export const useMapper = <T>(keyField: keyof T, array: T[]) => {
  const mapper = new Map<T[keyof T], T>()
  for (const el of array) {
    mapper.set(el[keyField], el)
  }
  return mapper
}
